import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    stores: {},
    outlets: {},
    products: {},
    sales: [],
    filter: null,
    region: 'world',
    chart_filters: {
      country: '',
    },
    country: [],
    line_chart_filters: 'year',
  },
  mutations,
  actions,
  getters,
};
